import React, { useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TruthSection } from './components/TruthSection';
import { OldSolutionsSection } from './components/OldSolutionsSection';
import { SolutionSection } from './components/SolutionSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { QualificationSection } from './components/QualificationSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { LegalModals } from './components/LegalModals';
export function App() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#e63946] selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <TruthSection data-id="element-3" />
      <OldSolutionsSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <DeliverablesSection data-id="element-6" />
      <QualificationSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <OfferSection data-id="element-9" />

      <footer className="bg-[#1e3a5f] text-blue-200 py-6 text-center text-sm" data-id="element-10">
        <div className="max-w-4xl mx-auto px-4" data-id="element-11">
          <div className="flex justify-center gap-4 mb-3" data-id="element-12">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white underline transition-colors" data-id="element-13">
              Política de Privacidad
            </button>
            <span data-id="element-14">•</span>
            <button onClick={() => setShowTerms(true)} className="hover:text-white underline transition-colors" data-id="element-15">
              Términos y Condiciones
            </button>
          </div>
          <p className="mb-1" data-id="element-16">
            © 2024 No Me Alcanza. Todos los derechos reservados.
          </p>
          <p className="opacity-60 text-xs" data-id="element-17">
            Este producto no garantiza resultados financieros sin la aplicación
            del método.
          </p>
        </div>
      </footer>

      <LegalModals showPrivacy={showPrivacy} showTerms={showTerms} onClosePrivacy={() => setShowPrivacy(false)} onCloseTerms={() => setShowTerms(false)} data-id="element-18" />
    </div>;
}